export const snakeToCamel = str =>
  str.replace(/([-_][a-z])/g, group =>
    group
      .toUpperCase()
      .replace('-', '')
      .replace('_', ''),
  );

export const parseCookies = () => {
  return Object.fromEntries(
    document.cookie.split(/; */).map(c => {
      const [key, ...v] = c.split('=');
      return [key, decodeURIComponent(v.join('='))];
    }),
  );
};

export const clearCookies = () => {
  const cookies = document.cookie.split('; ');
  // eslint-disable-next-line no-plusplus
  for (let c = 0; c < cookies.length; c++) {
    const d = window.location.hostname.split('.');
    while (d.length > 0) {
      const cookieBase = `${encodeURIComponent(
        cookies[c].split(';')[0].split('=')[0],
      )}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=${d.join('.')} ;path=`;
      // eslint-disable-next-line no-restricted-globals
      const p = location.pathname.split('/');
      document.cookie = `${cookieBase}/`;
      while (p.length > 0) {
        document.cookie = cookieBase + p.join('/');
        p.pop();
      }
      d.shift();
    }
  }
};


export const deduplicateLogs = (records) => {
  // this checks for duplicate logs based on SerialID, then keeps the one with the longest (or non-null) Flights or MaintenanceItems
  const uniqueMap = records.reduce((acc, item, index) => {
    const key = `${item.SerialID}-${item.AircraftID}`;
    const existing = acc.get(key);

    if (!existing) {
      acc.set(key, { item, index });
      return acc;
    }

    const currentIsValid = item.Flights != null || item.MaintenanceItems != null;
    const existingIsValid = existing.item.Flights != null || existing.item.MaintenanceItems != null;

    if (currentIsValid && !existingIsValid) {
      acc.set(key, { item, index });
      return acc;
    }

    if (!currentIsValid) {
      return acc;
    }

    const currentLength1 = item.Flights?.length;
    const existingLength1 = existing.item.Flights?.length;

    if (currentLength1 > existingLength1) {
      acc.set(key, { item, index });
    } else if (currentLength1 === existingLength1) {
      const currentLength2 = item.MaintenanceItems?.length;
      const existingLength2 = existing.item.MaintenanceItems?.length;

      if (currentLength2 > existingLength2) {
        acc.set(key, { item, index });
      }
    }

    return acc;
  }, new Map());

  // Sort by original index to preserve order
  return Array.from(uniqueMap.values())
    .sort((a, b) => a.index - b.index)
    .map(entry => entry.item);
}
